import CheckCircleFilled from "@ant-design/icons/CheckCircleFilled";
import ExclamationCircleOutlined from "@ant-design/icons/ExclamationCircleOutlined";
import IssuesCloseOutlined from "@ant-design/icons/IssuesCloseOutlined";
import { FollowSignalType } from "@shared/features/signals/common/types";
import { ActionTooltip } from "common/Tooltips/ActionTooltip";
import {
  LanguageNameSpaces,
  OneClickFollowBotData,
  SymbolClientsData,
} from "@shared/types";
import { useTheme } from "styled-components";
import { useContext } from "react";
import { FollowSignalsContext } from "@shared/features/signals/common/FollowSignals.context";
import { getListItemFollowData } from "@shared/features/signals/common/utils";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";

interface ListItemActionTooltipProps {
  accountData?: SymbolClientsData;
  botData?: OneClickFollowBotData;
  handleClick?: () => void;
}

const ListItemActionTooltip = ({
  accountData,
  botData,
  handleClick,
}: ListItemActionTooltipProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.SIGNALS);
  const { signal, followType } = useContext(FollowSignalsContext)!;
  const appTheme = useTheme();

  const clientId = accountData?.id;
  const botId = botData?.id;
  if ((!clientId && !botId) || !signal) return null;

  const { tradeExists, requiresCancel, requiresUpdate } = getListItemFollowData(
    signal,
    accountData,
    botData
  );

  let Icon = CheckCircleFilled;
  let iconColor = appTheme.colors.green;
  let title = "";
  let body;
  if (followType === FollowSignalType.FOLLOW && tradeExists) {
    title = t("follow.messages.already_followed");
    body = t("follow.messages.exchange_trade_exists");
  } else if (followType === FollowSignalType.UPDATE) {
    if (requiresUpdate) {
      title = t("follow.actions.signal_updated");
      body = t("follow.actions.update_trade");
      Icon = IssuesCloseOutlined;
      iconColor = appTheme.colors.gold;
    } else if (tradeExists) {
      title = t("follow.messages.trade_already_updated");
    }
  } else if (followType === FollowSignalType.CANCEL) {
    if (requiresCancel) {
      title = t("follow.actions.signal_canceled");
      body = t("follow.actions.close_trade");
      Icon = ExclamationCircleOutlined;
      iconColor = appTheme.colors.red;
    }
  }

  return (
    <>
      {title && (
        <ActionTooltip
          title={title}
          body={body}
          onClick={handleClick}
          containerStyle={{ display: "contents" }}
        >
          <Icon
            style={{
              color: iconColor,
              marginLeft: 8,
              fontSize: appTheme.typography.fontSizes.M,
            }}
          />
        </ActionTooltip>
      )}
    </>
  );
};

export default ListItemActionTooltip;
